export const YM_GOALS = {
  ACCOUNT_ACTIVATION: 'account_activation',
  REGISTER_NEW: 'register_new',
  ADGRAM_SOON_CLICK: 'adgram-soon-click',
  PAYMENT_PROFILE_CREATE: 'payment-profile-create',
  SEND_USER_TO_PAYMENT_PAGE: 'send-user-to-payment-page',
  USER_403: 'user-403',
  NEW_NETWORK_ACCOUNT: 'new-network-account',
  REPLENISHMENT_BALANCE: 'replenishment_balance',
  LEAD_MANAGER_CONNECTION_CREATED: 'lead manager: connection created',
}

/** @param {string} networkType */
export const getNetworkRegisterGoal = (networkType) => `${networkType}-register`
